export default "/wp-content/themes/oportun/dist/assets/brand/icons-e36237469627580c.svg"